export const routes = (prefix = `inpatients`) => [
    {
        path: `/${prefix}/dailyreport-list`,
        name: `${prefix}.dailyreport-list.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.dailyreport-list.index`,
                PageDescription: "Inpatient:Daily Report",
            },
        },
    },
     
];
